export default __webpack_public_path__ + "static/media/No.8-3.0f690718.jpg";